import { gql } from "@apollo/client"
import craftApolloClient from "./api/apollo"

import { useContext } from "react"
import { GlobalContext } from './_app'

import _ from 'lodash'

import { formatInTimeZone } from "date-fns-tz"

import Head from "next/head"

import { Header } from "../fuselage/global/header/header"
import { Footer } from '../fuselage/theme/2024/layout/footer/footer'
import { HeaderShim } from '../fuselage/global/header/header'

import handleContentBlocks from "../lib/content-blocks"
import handleSeomaticMeta from "../lib/seomatic"

import { 
    QueryPageHeader,
    QueryText, 
    QueryCards,
    QueryFlipFlops, 
    QueryFloaters, 
    QueryBillboards, 
    QueryBillboardSliders, 
    QueryImpactFigures, 
    QueryVideos,
    QueryForm,
    QueryProfileCarousel,
    QueryOffsetCallout,
    QuerySEO,
    QueryImages,
    QuerySpacer,
    QueryDividers,
    QueryPartners,
    QueryTestimonials,
    QueryCustomFrontendModule
} from "../graphql/queries"

import { buildAgenda } from "../lib/build-agenda"
import { SpeakerCard } from "./agenda"




export default function Page ({ entry, agenda }) {

    const globals = useContext(GlobalContext)

    // console.log('entry:', entry)
    // console.log('aviadevContentBlocks:', entry.aviadevContentBlocks)
    // console.log('agenda:', agenda)


    const injectCustomContentBlock = (blocks, heading, customContent) => {
        if (!blocks) return
        
        const blockIndex = blocks.findIndex(block => block.heading === heading)

        const updatedBlock = { ...blocks[blockIndex], content: customContent }

        const updatedBlocks = blocks.map(block => block.heading === heading ? updatedBlock : block)

        return updatedBlocks
    }




    // LEASING FORUM AGENDA

    const Agenda = () => {
        return (
            <section className="block bg-default">
                <div className="container">
                    <p className="fs-1 fw-600 c-primary">2026 Agenda</p>
                </div>

                <div className="container">
                    {
                        buildAgenda(agenda).map((day, index) => {
                            if (index < 1) return (
                                <section key={index} className='day'>
                                    <p className='dayDivider'> { day.day }</p>
                                    {
                                        day.timeslots.length ?
                                        day.timeslots.map( (slot, index) => {

                                            return (
                                                <>
                                                    {/* REGULAR SESSIONS */}

                                                    <div key={index} className='timeSlot'>

                                                        <div className='timingsAndTags fw-500 c-primary'>
                                                            {formatInTimeZone( new Date(slot.beginsAt), 'Europe/London', "HH:mm" )} - {formatInTimeZone( new Date(slot.endsAt), 'Europe/London', "HH:mm" )}
                                                        </div>
                                                        
                                                        <div className="sessions">
                                                            {
                                                                slot.sessions.map( (session, index) => {
                                                                    return (
                                                                        <div key={index} className="sessionsWrapper">
                                                                            {
                                                                                slot.sessions.length > 1 &&
                                                                                <div className="sessionStream | fw-600 c-white">Stream {index + 1}</div>
                                                                            }

                                                                            <div className='session | columns-1 gap-xs'>
                                                                                <p className="sessionTitle | fs-4 fw-600 lh-1 c-secondary">{ session.title }</p>

                                                                                {/* <div className='sessionTagGrid'>
                                                                                    [tags]
                                                                                </div> */}

                                                                                <div dangerouslySetInnerHTML={{ __html: session.descriptionRtf }} />
                                        
                                                                                { 
                                                                                    session.speakers.length ?
                                                                                    session.speakers.map( (item, index) => {
                                                                                        if (item.__typename === 'speakers_heading_BlockType') return (
                                                                                            <p key={index} className="fs-sm caps fw-500 c-primary">{ item.heading }</p>
                                                                                        )
                                                                                        return (
                                                                                            <div key={index} className='sessionSpeakerGrid'>
                                                                                                {
                                                                                                    item.speakers.map( speaker => (
                                                                                                        <SpeakerCard key={speaker.id} speaker={speaker} />
                                                                                                    ))
                                                                                                }
                                                                                            </div>
                                                                                        )
                                                                                    })
                                                                                    : null
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>

                                                    </div>
                                                </>
                                            )
                                        }) : <p key={index} className="fs-5 fw-400 py-xs">No sessions available on this day.</p>
                                    }
                                </section>
                            )
                        })
                    }
                </div>
            </section>
        )
    }




    return (
        <>

            <Head>
                { handleSeomaticMeta(entry.seomatic) } 
            </Head>

            <Header mainMenu={globals.nodes} />
            <HeaderShim />
            
            { handleContentBlocks(injectCustomContentBlock(entry.aviadevContentBlocks, "Agenda", <Agenda/>)) }

            <Footer 
				socialConnections={globals.globalSets[2].socialConnections} 
				contactInfo={globals.globalSets[2].contactDetails[0].body}
				hubspotForm={globals.globalSets[2].hubspotForm[0] ? globals.globalSets[2].hubspotForm[0] : null}
			/>

        </>
    )
}
Page.theme = 'aviadev-2024'


export async function getStaticPaths() {

    const entriesData = await craftApolloClient().query({
        query: gql`
            query Pages {
                entries(site: "${process.env.SITE_HANDLE}", section: "${process.env.SITE_HANDLE}Pages") {
                    slug
                }
            }
        `
    })

    const entries = await entriesData.data.entries

    return {
        paths: entries.map( entry => ({ params: { slug: entry.slug } })),
        fallback: false
    }

}

export async function getStaticProps({ params, preview, previewData }) {


    // fetch agenda

    let agendaData

    if (params.slug === "aviadev-finance-and-leasing-forum") {
        const agendaQuery = await craftApolloClient().query({
            query: gql`
                query Page {
                    sessions: entries(site: "aviadev", section: "aviadevAgenda2026", type: "session") {
                        ... on aviadevAgenda2026_session_Entry {
                            id
                            title
                            beginsAt
                            endsAt
                            descriptionRtf
                            speakers {
                            ... on speakers_heading_BlockType {
                                id
                                heading
                            }
                            ... on speakers_speakers_BlockType {
                                id
                                speakers {
                                ... on profiles_profile_Entry {
                                    id
                                    title
                                    positions {
                                    ... on positions_BlockType {
                                        id
                                        jobTitle
                                        organisation
                                    }
                                    }
                                    avatar {
                                    ... on avatars_Asset {
                                        id
                                        url
                                        width
                                        height
                                    }
                                    }
                                }
                                }
                            }
                            }
                            aviadevLocation {
                            ... on aviadevLocations_Category {
                                id
                                title
                            }
                            }
                            aviadevTopics {
                            ... on aviadevTopics_Category {
                                id
                                title
                            }
                            }
                        }
                    }
                    
                }
            `
        })
        agendaData = agendaQuery
    }


    // fetch regular content-blocks

    const entryData = await craftApolloClient( preview, previewData ).query({
        query: gql`
            query Page {
                entry(site: "${process.env.SITE_HANDLE}", slug: "${params.slug}") {
                    ... on ${process.env.SITE_HANDLE}Pages_page_Entry {
                        id
                        title
                        slug
                        ${process.env.SITE_HANDLE}ContentBlocks {
                            ${QueryPageHeader}
                            ${QueryText}
                            ${QueryCards}
                            ${QueryFlipFlops}
                            ${QueryFloaters}
                            ${QueryBillboards}
                            ${QueryBillboardSliders}
                            ${QueryImpactFigures}
                            ${QueryVideos}
                            ${QueryProfileCarousel}
                            ${QueryForm}
                            ${QueryImages}
                            ${QuerySpacer}
                            ${QueryDividers}
                            ${QueryOffsetCallout}
                            ${QueryPartners}
                            ${QueryTestimonials}
                            ${QueryCustomFrontendModule}
                        }
                        ${QuerySEO}
                    }
                }
            }
        `
    })

    const page = entryData



    return { 
        props: { 
            entry: page.data.entry,
            agenda: agendaData? agendaData.data.sessions : null
        }
    }
}